import React from 'react';
import PageHeader from '../components/ui/PageHeader';
import SectionHeading from '../components/ui/SectionHeading';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <div className="bg-white min-h-screen">
      <PageHeader title="About Veloura" bgImage="https://images.unsplash.com/photo-1560066984-138dadb4c035?auto=format&fit=crop&q=80&w=2000" />
      
      <div className="container mx-auto px-6 max-w-6xl py-24">
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            className="lg:w-1/2 relative"
          >
            <div className="aspect-[3/4] rounded-t-full overflow-hidden border-8 border-veloura-bg shadow-xl">
              <img 
                src="https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&q=80&w=800" 
                alt="Sophia Laurent - Founder" 
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-white p-6 shadow-lg rounded-xl">
              <h3 className="font-serif text-2xl text-veloura-text">Sophia Laurent</h3>
              <p className="text-veloura-accent uppercase tracking-wider text-xs font-semibold mt-1">Founder & Master Lash Artist</p>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            className="lg:w-1/2"
          >
            <SectionHeading title="Our Story" subtitle="The Visionary" centered={false} />
            
            <div className="space-y-6 text-lg text-veloura-muted leading-relaxed">
              <p>
                Founded in 2018, Veloura Lash Studio was born out of a passion for intricate beauty and a desire to elevate the standard of lash artistry in Montreal. Sophia Laurent, a certified Master Lash Artist, envisioned a space where luxury meets technical perfection.
              </p>
              <p>
                "I wanted to create more than just a salon. I wanted a sanctuary where women could come to rest, rejuvenate, and wake up feeling effortlessly beautiful. Lashes are an art form, and every set we create is customized to the individual's facial structure and natural lash health."
              </p>
              <p>
                With over 8 years of experience and multiple international certifications, Sophia has meticulously trained her team to adhere to the highest standards of safety, hygiene, and design. We use only premium, cruelty-free materials and medical-grade adhesives.
              </p>
            </div>

            <div className="mt-12 grid grid-cols-2 gap-6 border-t border-veloura-primary/30 pt-8">
              <div>
                <h4 className="font-serif text-4xl text-veloura-accent mb-2">5+</h4>
                <p className="text-sm text-veloura-text uppercase tracking-wider font-semibold">Years in Business</p>
              </div>
              <div>
                <h4 className="font-serif text-4xl text-veloura-accent mb-2">3k+</h4>
                <p className="text-sm text-veloura-text uppercase tracking-wider font-semibold">Happy Clients</p>
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </div>
  );
};

export default About;